import { TrackingEvent } from '@caresend/types';
import '@caresend/utils';
import { reportException } from '../../../../functions/sentry.js';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import 'dayjs';
import { getStore } from '../../../../store/helpers/initStore.js';
import { trackEvent } from '../../../../functions/tracking/tracking.js';

/** Only tracked upon result submission */
const trackChartingDone = (waypointActionID, procedureID, productID, resultText) => {
    const store = getStore();
    const waypointAction = store.state.waypoint.waypointActions[waypointActionID];
    if (!waypointAction) {
        reportException(`Charting Done tracking failed on procedure ${procedureID}`);
        return;
    }
    trackEvent(store, TrackingEvent.CHARTING_DONE, {
        waypointActionID,
        itineraryID: waypointAction.itineraryID,
        procedureID,
        result: resultText,
        productID,
    });
};

export { trackChartingDone };
